import {h, Fragment} from "preact"
import { useEffect, useState, useMemo } from "preact/hooks"

import { addToCart, sortData } from "../helpers"
import { sizeOrder } from "../config"

export default function MobileQuickAdd({ open, setOpen, product, setSizeGuideOpen }) {
    const [ selectedSize, setSelectedSize ] = useState(null);
    const sortedSkus = useMemo(() => sortData(product?.skus, sizeOrder, (sku) => sku.customFields?.find(f => f.key === 'size')?.value), [ product?.skus ]);
    const isPreorder = useMemo(() => product?.tags1?.find(t => t.toLowerCase() === 'preorder'), [ product ]);

    useEffect(() => { // lock scroll on mobile
        if (open) {
            document.body.style.overflow = 'hidden';
            document.querySelector(`#ns-quickadd-${product?.productId} .ns-quickadd-btn:not([disabled])`)?.focus();
        } else {
            document.body.style.overflow = '';
        }

        return () => document.body.style.overflow = '';
    }, [ open, product?.productId ]);

    const handleClose = () => {
        const triggerButton = document.querySelector(`[aria-controls="ns-quickadd-${product?.productId}"]`);
        if (triggerButton) {
            triggerButton.focus();
        }
        setOpen(false);
    };

    const handleAddToCart = async (e, id) => {
        e.preventDefault();
        await addToCart(id || selectedSize, isPreorder);
        handleClose();
    }

    return (
        <>
            <div
                id={`ns-quickadd-${product?.productId}`}
                class="ns-product-quickadd ns-fixed ns-lg-absolute ns-flex ns-flex-col"
                aria-modal="true"
                role="dialog"
                aria-label="Select product size to add to cart"
                aria-hidden={!open}
            >

                <div class="ns-quickadd-header ns-flex ns-flex-nowrap ns-items-center ns-justify-between">
                    <button 
                        type="button"
                        class="ns-sizeguide-toggle ns-lg-hidden"
                        aria-label="Open size guide"
                        onClick={() => setSizeGuideOpen(true)}
                    >
                        Size Guide
                    </button>
                    <button
                        type="button"
                        class="ns-quickadd-close ns-relative ns-flex ns-lg-hidden"
                        aria-label="Close quick add"
                        aria-expanded={open}
                        onClick={handleClose}
                    >
                        <span class="sr-only visually-hidden">Close Quick Add</span>
                        <span 
                            class="ns-close-icon ns-block ns-absolute"
                            role="presentation"
                            aria-hidden="true"
                        />
                    </button>

                    <h5 class="ns-quickadd-heading">Quick Add</h5>
                </div>

                <div class="ns-quickadd-sizes ns-w-100 ns-custom-scrollbar">
                    <p class="sr-only visually-hidden">Select Size:</p>
                    <ol class="ns-w-100 ns-flex ns-flex-col ns-items-center ns-justify-center ns-lg-flex-row ns-lg-justify-start">
                        {sortedSkus.map(sku => {
                            const size = sku.customFields.find(f => f.key === 'size')?.value;
                            return (
                                <li
                                    key={sku.id}
                                    type="button"
                                    class="ns-quickadd-size ns-block ns-w-100"
                                    aria-label={`Add ${product?.name} size ${size} to cart`}
                                    disabled={sku.availability !== 'InStock'}
                                    >
                                    <input
                                        class="sr-only visually-hidden"
                                        type="radio"
                                        name={`quickadd-${product?.productId}-size`}
                                        id={`quickadd-${product?.productId}-size-${sku.id}`}
                                        value={sku.id}
                                        disabled={sku.availability !== 'InStock'}
                                        checked={selectedSize === sku.id}
                                        onChange={(e) => setSelectedSize(sku.id)}
                                    />
                                    <label 
                                        class="ns-quickadd-size-label ns-w-100 text-center"
                                        htmlFor={`quickadd-${product?.productId}-size-${sku.id}`}
                                        tabIndex={0}
                                    >
                                        {size}
                                    </label>
                                </li>
                            )
                        })}
                    </ol>
                </div>
                <button 
                    type="button"
                    disabled={!selectedSize}
                    class="ns-quickadd-atc ns-lg-hidden ns-w-100"
                    onClick={handleAddToCart}
                >
                    {selectedSize ? 'Add to Bag' : 'Select Size'}
                </button>
            </div>
            <div
                class="ns-quickadd-backdrop ns-fixed ns-lg-hidden"
                onClick={handleClose}
                aria-hidden="true"
            />
        </>
    )
}
